// 引入高德地图插件
import AMapLoader from '@amap/amap-jsapi-loader'
// 编写安全密钥
window._AMapSecurityConfig = {
	securityJsCode: 'a2d99259817a9b722acc7dd0f35b4f26'
}
const initMap = async () => {
	return new Promise((resolve, reject) => {
		AMapLoader.load({
			// key: 'db9425dcc27b44b05ae0dc6f70ebbd83',  //设置您的key   公司
			key: '0323acfa782cd29101908e3bb3cd7e4f',  //设置您的key   公司
			version: "2.0",
			plugins: ['AMap.ToolBar', 'AMap.Driving', 'AMap.Scale','AMap.PlaceSearch','AMap.AutoComplete','AMap.Geocoder'],
			Loca: {
				version: "2.0"
			},
		}).then((AMap) => {
			resolve(AMap)
			// Vue.prototype.$Amap = AMap
			// window.Amap = amap
		}).catch(err => {
			reject(err)
		})
	})
}
export default initMap
